import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { InView } from 'react-intersection-observer';
import { useLocaleContext } from '../../../context/LocaleContext';
import PollItem, { STATUS_POLL } from './PollItem';
import './index.scss';

const PollList = ({
    defaultPolls,
    unreadPolls,
    answeredPolls,
    isEmpty,
    onReadPoll,
    readCurrentPollIds,
    readPollIds,
}) => {
    const $locale = useLocaleContext();
    const navigate = useNavigate();

    const onPollHandler = (poll) => {
        navigate(`${window.location.pathname}?view-poll-id=${poll?.id}`);
    }

    const inVisible = useCallback((inView, pollId) => {
        if (inView && !readCurrentPollIds.includes(pollId) && !readPollIds.includes(pollId)) {
            onReadPoll(pollId);
        }
    }, [readCurrentPollIds, onReadPoll, readPollIds]);

    return (
        <div className="poll-list-container">
            <div className={`poll-list-container-main scrollable ${isEmpty ? "-empty" : ""}`}>
                {unreadPolls?.map(poll => (
                    <InView key={poll.id} onChange={(inView) => inVisible(inView, poll.id)}>
                        <PollItem
                            key={poll.id}
                            status={STATUS_POLL.new}
                            poll={poll}
                            $locale={$locale}
                            onPollHandler={onPollHandler}
                        />
                    </InView>
                ))}
                {defaultPolls?.map(poll => (
                    <PollItem
                        key={poll.id}
                        poll={poll}
                        $locale={$locale}
                        onPollHandler={onPollHandler}
                    />
                ))}
                {answeredPolls?.map(poll => (
                    <PollItem
                        key={poll.id}
                        status={STATUS_POLL.answered}
                        poll={poll}
                        $locale={$locale}
                        onPollHandler={(poll) => !poll.private && onPollHandler(poll)}
                    />
                ))}

                {isEmpty && (
                    <span className="label-empty">
                        {$locale.get("polls.listEmpty")}
                    </span>
                )}
            </div>
        </div>
    )
};

export default PollList;
